export const styles = {
  root: 'grow',
  skeleton: 'w-[14rem] h-[4.8rem]',
  img: 'w-full h-full',
  button: 'mt-auto',
};
